import React from 'react';
import ReactDOM from 'react-dom';
import './styles/main.scss';
import Fitil from './components/Fitil';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<Fitil />, document.getElementById('root'));
registerServiceWorker();
